import { InjectionToken } from '@angular/core';

// Define and use an InjectionToken object for choosing a provider token for non-class dependencies.
export const LOGROCKET_ENVIRONMENT_ID = new InjectionToken<string>('LogRocket application id');
